import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, isAuthenticated, redirectPath, ...rest }) => {
  return (
    <Route { ...rest} render={props => {
      return (
        isAuthenticated ? (
          <Component {...props}/>
        ) : (
          <Redirect to={{
            pathname: redirectPath,
            state: { from: props.location },
          }}/>
        )
      );
    }}/>
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  redirectPath: PropTypes.string.isRequired,
  location: PropTypes.object,
  exact: PropTypes.bool,
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./client/src/components/private-route.js